import { Attributes, Meter, MetricOptions } from '@opentelemetry/api';
import { Histogram as OtelHistogram } from '@opentelemetry/api';

/**
 * Histogram can be used to track time-based metrics for example the latency of requests.
 * This class wraps the OpenTelemetry Histogram API to add global attributes.
 */

export class Histogram {
  // The OpenTelemetry Histogram instance
  private readonly histogram: OtelHistogram;

  // The global attributes that will be added to all histogram metrics
  private readonly attributes: Attributes;

  constructor({
    name,
    meter,
    options,
    attributes,
  }: {
    meter: Meter;
    name: string;
    options?: MetricOptions;
    attributes: Attributes;
  }) {
    this.histogram = meter.createHistogram(name, options);
    this.attributes = attributes;
  }

  /**
   * Record a value to the histogram with the global attributes.
   *
   * @param value - The value to record. Value of the measurement must not be negative.
   * @param attributes - Optional attributes to add to this specific record.
   */
  record: typeof this.histogram.record = (value, attributes) => {
    return this.histogram.record(value, {
      ...this.attributes,
      ...attributes,
    });
  };
}
